import React, { useEffect, useState } from 'react';
import { Product } from '@services';
import classNames from 'classnames/bind';
import styles from './ProductSuggestionItem.module.scss';
import { Price } from '@components';
import { Typography } from 'gd-design-library';
import NoImagePlaceholder from '@assets/images/no-image-placeholder.png';
import { getSuccessfullyLoadedUrls } from '@utils';
import Highlighter from 'react-highlight-words';

interface ProductSuggestionItemProps {
  product: Product;
  searchTerm: string;
}

const CN = 'product-suggestion-item';
const imageClassName = `${CN}--image`;
const infoClassName = `${CN}--info`;
const cx = classNames.bind(styles);

export const ProductSuggestionItem: React.FC<ProductSuggestionItemProps> = ({
  product: {
    name,
    price,
    image
  },
  searchTerm
}) => {
  const [ loadedImage, setLoadedImage ] = useState('');
  useEffect(() => {
    getSuccessfullyLoadedUrls([ image ]).then(([ loadedImageResult ]) => {
      setLoadedImage(loadedImageResult?.length ? loadedImageResult : NoImagePlaceholder.src);
    });
  }, [ image ]);

  return (
    <div className={ cx(CN) }>
      <img src={ loadedImage } className={ cx(imageClassName) } />
      <div className={ cx(infoClassName) }>
        <Typography>{ <Highlighter
          searchWords={ searchTerm.split(/\s+/).filter(word => word.length > 0) }
          autoEscape={ true }
          textToHighlight={ name }
          highlightTag='span'
          highlightStyle={ { fontWeight: 'bold' } }
        />
        }</Typography>
        <Price price={ price } />
      </div>
    </div>
  );
};
